export type CanalInscricao = "SITE" | "APP" | "PAINEL";
export type PlataformaApp = "IOS" | "ANDROID";

export function formatCanalInscricaoLabel(
  canal?: CanalInscricao | null,
  plataforma?: PlataformaApp | null,
): string {
  if (!canal || canal === "SITE") return "Site";
  if (canal === "PAINEL") return "Painel";
  if (plataforma === "IOS") return "App iOS";
  if (plataforma === "ANDROID") return "App Android";
  return "App";
}

export function canalInscricaoIcon(
  canal?: CanalInscricao | null,
  plataforma?: PlataformaApp | null,
): string {
  if (!canal || canal === "SITE") return "language";
  if (canal === "PAINEL") return "admin_panel_settings";
  if (plataforma === "IOS") return "phone_iphone";
  if (plataforma === "ANDROID") return "android";
  return "smartphone";
}
